var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperator2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,21.5c-8.95833,0 -16.58922,3.61742 -21.486,9.1263c-4.89679,5.50889 -7.18066,12.57277 -7.18066,19.54036c0,6.96759 2.28388,14.03148 7.18066,19.54036c4.89679,5.50888 12.52767,9.1263 21.486,9.1263c8.95833,0 16.58921,-3.61742 21.486,-9.1263c4.89678,-5.50889 7.18066,-12.57277 7.18066,-19.54036c0,-6.96759 -2.28388,-14.03148 -7.18066,-19.54036c-4.89679,-5.50889 -12.52767,-9.1263 -21.486,-9.1263zM121.83333,78.83333c-7.83362,0 -14.33333,6.49972 -14.33333,14.33333v7.16667h-7.16667c-7.88333,0 -14.33333,6.45 -14.33333,14.33333v14.33333c0,3.94167 3.225,7.16667 7.16667,7.16667h28.66667v-7.16667h14.33333v7.16667h28.66667c3.94167,0 7.16667,-3.225 7.16667,-7.16667v-14.33333c0,-7.88333 -6.45,-14.33333 -14.33333,-14.33333h-7.16667v-7.16667c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333zM121.83333,93.16667h14.33333v7.16667h-14.33333zM75.11003,101.0472c-22.93334,2.72333 -53.61003,13.47614 -53.61003,31.53614v17.91667h50.16667v-35.83333c0,-4.945 1.29336,-9.60614 3.44336,-13.61947zM86,149.21224v8.45443c0,7.88333 6.45,14.33333 14.33333,14.33333h57.33333c7.88333,0 14.33333,-6.45 14.33333,-14.33333v-8.45443c-2.22167,0.86 -4.65833,1.28776 -7.16667,1.28776h-71.66667c-2.50833,0 -4.945,-0.42776 -7.16667,-1.28776z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator2);
export default __webpack_public_path__ + "static/media/operator2.abb201944232f1c88ad2597da2d590da.svg";
export { ForwardRef as ReactComponent };